import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import Logger, { LOG_LEVELS } from '../../utils/logger';
import GlobalFilterPanel, {FILTER_PERIOD_GROUP, FIELDS} from '../filter/GlobalFilterPanel';
import ErrorsAndWarningsCategorySelector  from './ErrorsAndWarningsCategorySelector';
import ErrorsAndWarningsVisibilitySelector from './VisibilitySelector';
import {ErrorWarningsCategory} from '../../utils/enums';
import GLOBAL_FILTER_CONTROLLER from '../../controllers/globalFilter';

const log = new Logger('ERRORS_AND_WARNINGS_FILTER_PANEL', LOG_LEVELS.DEBUG);

export class ErrorsAndWarningsFilterPanel extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selection: {
        includeErrors: true,
        includeWarnings: true
      },
      disableSearch: true,
      filteredCountries: [],
      isCountryFilterEnabled: false
    };
    this.selectionHandler = this.selectionHandler.bind(this);
    this.onSearchClick = this.onSearchClick.bind(this);
    this.onFieldChange = this.onFieldChange.bind(this);
    this.categoryList = ErrorWarningsCategory.enumValues;
  }

  onSearchClick(selection) {
    log.debug('onSearchClick() ');
    log.debug('onSearchClick(): state.selection: ', this.state.selection);
    log.debug('onSearchClick(): selection: ', selection);
    let combinedSelection = Object.assign({}, this.state.selection, selection);
    log.debug('onSearchClick(): combinedSelection: ', combinedSelection);
    this.props.onSearchClick(combinedSelection);
  }

  onFieldChange(keyValue, selection) {
    log.debug('onFieldChange() - keyValue: ', keyValue, 'selection: ', selection);
    const key = Object.keys(keyValue)[0];

    // Listen for company selection changes
    if (key === FIELDS.PARAM_COMPANY_ID) {
      const companyId = keyValue[FIELDS.PARAM_COMPANY_ID];
      this.handleCompanyChange(companyId);
    }
    this.props.onFilterChange();
  }

  // Disabling/enabling the country filter here only updates display state
  // (filteredCountries / isCountryFilterEnabled), which GlobalFilterPanel receives as the
  // `countries` prop. GlobalFilterPanel itself is responsible for dropping a selected
  // countryCode once it falls outside that prop's list - see VRS-2355.
  handleCompanyChange(companyId) {
    log.debug('handleCompanyChange() - companyId: ', companyId);

    // If no company selected or 'All' selected, disable country filter
    if (!companyId || companyId === 'All' || companyId === '' || companyId === 0) {
      this.setState({
        filteredCountries: [],
        isCountryFilterEnabled: false
      });
      return;
    }

    // Find the selected company from the company list
    const companies = this.props.companies || [];
    const selectedCompany = companies.find(company =>
      company.id === parseInt(companyId, 10) || company.id === companyId
    );

    if (!selectedCompany) {
      log.debug('handleCompanyChange() - Company not found');
      this.setState({
        filteredCountries: [],
        isCountryFilterEnabled: false
      });
      return;
    }

    // Get VAT numbers from the company
    const vatNumbers = selectedCompany.vatNumbers || [];

    if (_.isEmpty(vatNumbers)) {
      log.debug('handleCompanyChange() - No VAT numbers found for company');
      this.setState({
        filteredCountries: [],
        isCountryFilterEnabled: false
      });
      return;
    }

    // Extract country codes from VAT numbers
    const countryCodesWithCompanyVAT = vatNumbers.map(vatDetails => vatDetails.vatnumberCountry);
    log.debug('handleCompanyChange() - countryCodesWithCompanyVAT: ', countryCodesWithCompanyVAT);

    // Filter countries based on VAT number countries
    const allCountries = this.props.countryList || [];
    const filteredCountries = allCountries.filter(countryDetails =>
      countryCodesWithCompanyVAT.includes(countryDetails.countryCode)
    );

    log.debug('handleCompanyChange() - filteredCountries: ', filteredCountries);

    // Enable country filter with filtered countries
    this.setState({
      filteredCountries: filteredCountries,
      isCountryFilterEnabled: true
    });
  }

  selectionHandler(keyValue) {
     let selection = Object.assign({}, this.state.selection, keyValue);
     this.setState({
       selection: selection
     });
     this.props.onFilterChange();
  }

  genericFilterSelectionHandlerFactory(fieldName) {
   return (value) => {
     let selection = Object.assign({}, this.state.selection);
     selection[fieldName] = value === '' ? undefined : value;
     this.setState({
       selection: selection
     });
     this.props.onFilterChange();
   };
  }

  genericInputHandlerFactory(fieldName) {
    return (evt) => {
      let selection =  Object.assign({}, this.state.selection);
      selection[fieldName] = evt.target.value === '' ? undefined : evt.target.value;
      this.setState({
        selection: selection
      });
      this.props.onFilterChange();
    };
  }

  genericCheckboxHandlerFactory(fieldName) {
    return (evt) => {
      let selection = Object.assign({}, this.state.selection);
      selection[fieldName] =  evt.target.checked || undefined;
      this.setState({
        selection: selection
      });
      this.props.onFilterChange();
    };
  }

  componentDidMount() {
    log.debug('componentDidMount() ');
    let selection = Object.assign({}, this.state.selection);
    if(this.props.includeErrors) {
      selection.includeErrors = this.props.includeErrors+'';
    }
    if(this.props.includeWarnings) {
      selection.includeWarnings = this.props.includeWarnings+'';
    }
    if(this.props.includeHidden) {
      selection.includeHidden = this.props.includeHidden+'';
    }
    if(this.props.errorCategory) {
      selection.errorCategory = this.props.errorCategory;
    }
    if(this.props.invoiceNumberFilter) {
      selection.invoiceNumberFilter = this.props.invoiceNumberFilter;
    }
    if(typeof this.props.invoiceNumberFilterExactMatch !== 'undefined') {
      selection.invoiceNumberFilterExactMatch = this.props.invoiceNumberFilterExactMatch;
    }
    this.setState({
      selection: selection
    });

    // Check for initial company selection from global filter
    const globalFilterValues = GLOBAL_FILTER_CONTROLLER.getAll() || {};   
    const companyId = globalFilterValues[FIELDS.PARAM_COMPANY_ID];
    if (companyId && this.props.companies && this.props.companies.length > 0) {
      this.handleCompanyChange(companyId);
    }
  }

  componentDidUpdate(prevProps) {
    let selection = Object.assign({}, this.state.selection);
    let updateState = false;
    if(this.props.includeErrors !== prevProps.includeErrors) {
      selection.includeErrors = this.props.includeErrors+'';
      updateState = true;
    }
    if(this.props.includeWarnings !== prevProps.includeWarnings) {
      selection.includeWarnings = this.props.includeWarnings+'';
      updateState = true;
    }
    if(this.props.includeHidden !== prevProps.includeHidden) {
      selection.includeHidden = this.props.includeHidden+'';
      updateState = true;
    }
    if(this.props.errorCategory !== prevProps.errorCategory) {
      selection.errorCategory = this.props.errorCategory;
      updateState = true;
    }
    if(this.props.invoiceNumberFilter !== this.props.invoiceNumberFilter) {
      selection.invoiceNumberFilter = this.props.invoiceNumberFilter;
      updateState = true;
    }
    if(this.props.invoiceNumberFilterExactMatch !== this.props.invoiceNumberFilterExactMatch) {
      selection.invoiceNumberFilterExactMatch = this.props.invoiceNumberFilterExactMatch;
      updateState = true;
    }
    
    // Check if companies prop changed and we need to re-evaluate company selection
    if(this.props.companies !== prevProps.companies && this.props.companies && this.props.companies.length > 0) {
      const globalFilterValues = GLOBAL_FILTER_CONTROLLER.getAll() || {};
      const companyId = globalFilterValues[FIELDS.PARAM_COMPANY_ID];
      if (companyId) {
        this.handleCompanyChange(companyId);
      }
    }
    
    if(updateState) {
      this.setState({
        selection: selection
      });
    }
  }

  render() {
    log.debug('render: ', this.props);
    const {selection, filteredCountries, isCountryFilterEnabled} = this.state;
    
    // Use filtered countries if enabled, otherwise use empty array (disabled)
    const countriesToShow = isCountryFilterEnabled ? filteredCountries : [];
    
    return (
      <s-box name="filter-panel">
          <GlobalFilterPanel 
            countries={countriesToShow} 
            onSearchClick={this.onSearchClick} 
            useErrorsAndWarningsSearchClick={true}
            isCountryFilterDisabled={!isCountryFilterEnabled}
            disableSearch={true} 
            onFieldChange={this.onFieldChange}
            hideElements={
              {
                'month': true,
                'year': true,
                returnType: true,
                returnStatus: true
              }
            }
            disableElements={{
              [FIELDS.PARAM_COUNTRY_CODE]: !isCountryFilterEnabled
            }}
            filterPeriodGroup={FILTER_PERIOD_GROUP.DATE_RANGE}
          >

            <ErrorsAndWarningsVisibilitySelector
              selectionHandler={this.selectionHandler}
              includeErrors={selection.includeErrors}
              includeWarnings={selection.includeWarnings}
              includeHidden={selection.includeHidden}
            />

            <ErrorsAndWarningsCategorySelector 
              selectionHandler={this.selectionHandler}
              categoryList={this.categoryList}
              value={selection.errorCategory || ''}
            />

            <fieldset>
              <label className="mr20"><LanguageStringResolver string='errorsAndWarnings_invoiceNumber'/></label>
              <input type="text" onChange={this.genericInputHandlerFactory('invoiceNumberFilter').bind(this)} value={this.state.selection.invoiceNumberFilter}/>
            </fieldset>
            
            <fieldset>
              <legend><LanguageStringResolver string='errorsAndWarnings_exactMatch'/></legend>
              <span className="clear"></span>
              <input 
                type="checkbox"
                onChange={this.genericCheckboxHandlerFactory('invoiceNumberFilterExactMatch').bind(this)}
                name="invoiceNumberFilterExactMatch"
                checked={selection.invoiceNumberFilterExactMatch !== undefined}
              />
              <label className="checkbox">True</label>
            </fieldset>
            
          </GlobalFilterPanel>
          <div className="clear"></div>
      </s-box>
    )
  }
}

function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  const globalFilterPanelData = (state.managedUxForms && state.managedUxForms.forms['GLOBAL_FILTER_PANEL']) || {};  
  const defaultCompanies = (state.companies && state.companies.data) || [];

  return {
    languages: state.languages,
    globalFilterValues: globalFilterPanelData.fieldValues,
    companies: defaultCompanies
  };
}



ErrorsAndWarningsFilterPanel.defaultProps = {
  onSearchClick: () => {},
  onFilterChange: () => {},
}
// Wrap the component to inject state into it
export default connect(mapStateToProps)(ErrorsAndWarningsFilterPanel);
